import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * Small uppercase section label used across the User Settings pages
 * ("Basic Information", "Change Password", "Organization Invitations", …).
 * Sections introduced by this label stack vertically and are separated by
 * hairline dividers instead of boxed cards.
 */
export function SettingsSectionLabel({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) {
  return (
    <h3
      className={cn(
        "text-xs font-semibold uppercase tracking-wider text-muted-foreground",
        className
      )}
      {...props}
    >
      {children}
    </h3>
  );
}
